export default __webpack_public_path__ + "assets/cc560f121c7e2fc738b5bd53902d98e1.png";